<template>
    <div class="page-container">
        <div class="toolbar" style="float:left;padding-top:10px;padding-left:15px;text-align:left">
            <el-form :inline="true" :model="filters" :size="size">
                <el-form-item label="数据ID">
                    <el-input
                        type="number"
                        style="width:140px"
                        v-model="searchByKeyword.dataId"
                        @mousewheel.native.prevent
                        placeholder="请输入数据ID"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="层次">
                    <el-select clearable v-model="searchByKeyword.diploma" placeholder="请选择层次" style="width:140px">
                        <el-option
                            v-for="item in diplomaList"
                            :key="item.value + 13"
                            :label="item.name"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
<!--                <el-form-item label="院校名称">-->
<!--                    <el-input v-model="searchByKeyword.schoolName" placeholder="请输入院校名称" style="width:140px" clearable></el-input>-->
<!--                </el-form-item>-->
                <el-form-item label="院校名称">
                    <el-select
                        remote
                        filterable
                        clearable
                        @change="$forceUpdate()"
                        :remote-method="getSchoolList"
                        v-model="searchByKeyword.schoolId"
                        placeholder="请输入院校名称"
                        style="width:140px">
                        <el-option
                            v-for="item in schoolList"
                            :key="item.schoolId + 3"
                            :label="item.schoolName"
                            :value="item.schoolId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开设专业名称">
                    <el-input v-model="searchByKeyword.profName" placeholder="请输入专业名称" style="width:140px" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <perm-button icon="fa fa-search" label="搜索" perms="wish:schoolprof:list" type="primary" @click="findPage({pageRequest:{current: 1,size: 10}})"/>
                </el-form-item>
                <el-form-item>
                    <perm-button icon="fa fa-plus" label="新增" perms="wish:schoolprof:add" type="success" @click="handleAdd"/>
                </el-form-item>
            </el-form>
        </div>
        <!--表格树内容栏-->
        <perm-table
            :page="page"
            :columns="columns"
            :selectionChange="selectionChange"
            :handleCurrentHandle="handleCurrentHandle"
            :loading="loading"
            size="mini"
            :showMore='false'
            :showEdit='true'
            :showDelete='true'
            @handleShoMore='handleShoMore'
            @findPage="findPage"
            @handleEdit="handleEdit"
            @handleDelete="handleDelete"
            permsEdit="wish:schoolprof:update"
            permsDelete="wish:schoolprof:delete">
        </perm-table>
        <table-column-filter-dialog
            ref="tableColumnFilterDialog"
            :columns="columns"
            @handleFilterColumns="handleFilterColumns">
        </table-column-filter-dialog>
        <!-- 新增修改界面 -->
        <el-dialog :title="!dataForm.dataId ? '新增院校专业信息' : '修改院校专业信息'" width="60%" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="cancel">
            <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="submitForm()"
                     label-width="130px" :size="size" style="text-align:left;">
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="数据年份" prop="dataYear">
                            <el-input type="number" @mousewheel.native.prevent @DOMMouseScroll.native.prevent
                                      placeholder="请输入数据年份" v-model="dataForm.dataYear" style="width:215px" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="院校名称" prop="schoolId">
<!--                            <el-input placeholder="请输入院校名称" v-model="dataForm.schoolName" style="width:215px" />-->
                            <el-select
                                remote
                                filterable
                                clearable
                                @change="$forceUpdate()"
                                :remote-method="getSchoolList"
                                v-model="dataForm.schoolId"
                                placeholder="请输入院校名称"
                                style="width:215px">
                                <el-option
                                    v-for="item in schoolList"
                                    :key="item.schoolId + 3"
                                    :label="item.schoolName"
                                    :value="item.schoolId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="开设专业" prop="schProfName">
                            <el-input placeholder="请输入开设专业名称" v-model="dataForm.schProfName" style="width:215px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="层次" prop="diploma">
                            <el-select v-model="dataForm.diploma" placeholder="请选择层次" style="width:215px">
                                <el-option
                                    v-for="item in diplomaList"
                                    :key="item.value + 133"
                                    :label="item.name"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="10">
                        <el-form-item label="选专业" prop="profName">
                            <el-input placeholder="请输入选专业名称" v-model="dataForm.profName" style="width:215px" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="备注" prop="remark">
                            <el-input type="textarea" placeholder="请输入备注信息" v-model="dataForm.remark" style="width:215px" />
                        </el-form-item>
                    </el-col>
                </el-row>
<el-form-item>
                    <div
                        style="display: flex; margin-top: 20px;margin-bottom: -10px"
                    >
                        <el-popover
                            placement="bottom-start"
                            :visible-arrow="false"
                            v-model="showImport"
                            @hide="handleCancelImportByUrl"
                        >
                            <el-row>
                                <div style="margin-bottom: 10px">
                                    导入网址：
                                </div>
                            </el-row>
                            <el-row>
                                <el-input
                                    style="width: 360px"
                                    placeholder="请使用ctrl+v或command＋v粘贴文章网址，以http开头"
                                    v-model="importUrl"
                                ></el-input>
                            </el-row>
                            <el-row style="margin-top: 10px">
                                <el-button
                                    type="primary"
                                    plain
                                    @click="handleImportByUrl"
                                    >确定</el-button
                                >
                                <el-button
                                    type="danger"
                                    plain
                                    @click="handleCancelImportByUrl"
                                    >取消</el-button
                                >
                            </el-row>
                            <el-button slot="reference" type="primary"
                                >导入链接文章</el-button
                            >
                        </el-popover>
                        <el-upload
                            style="margin-left: 20px"
                            ref="upLoadPDFForm"
                            :headers="headers"
                            class="upload"
                            accept=".pdf"
                            :before-upload="beforePDFUpload"
                            :on-error="handleErrorPDF"
                            :with-credentials="true"
                            :action="upload.pdfUrl"
                            :show-file-list="false"
                            :on-success="handleSuccessPDF"
                            :limit="1"
                        >
                            <el-button size="small" type="primary"
                                >导入PDF</el-button
                            >
                        </el-upload>
                    </div>
                </el-form-item>
                <el-form-item label="专业介绍" prop="intro">
                    <!-- <div id="intro"></div> -->
                    <div id="editor"></div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button :size="size"  @click="cancel">取消</el-button>
                <el-button :size="size"  type="primary" :loading="editLoading" @click="submitForm()">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import PopupTreeInput from '../../Component/PopupTreeInput/Index'
import PermButton from '../../Component/PermButton/Index'
import PermTable from '../../Component/PermTable/Index'
import MyCustomUploadAdapterPlugin from '@/utils/uploadAdapter'
import TableColumnFilterDialog from '../../Component/TableColumnFilterDialog/Index'
import E from 'wangeditor'
import { uploadUrl } from '../../../utils/global'
import { Loading } from 'element-ui'
export default {
    name: 'SchoolProf',
    components: {
        PermTable,
        PermButton,
        PopupTreeInput,
        TableColumnFilterDialog
    },
    data() {
        return {
            summaryBox: '',
            editor: '',
            dialogVisible: false,
            columns: [],
            editLoading: false,
            loading: false,
            filterColumns: '',
            page: {},
            filters: {},
            size: 'small',
            pageRequest: {
                current: 1,
                size: 10
            },
            schoolList: {},
            dataForm: {
                profId: '',
                profName: '',
                diploma: '',
                dataYear: '',
                schProfName: '',
                schoolId: '',
                schoolName: '',
                remark: '',
                intro: ''
            },
            dataRule: {
                profName: [{ required: true, message: '选专业名称不能为空', trigger: 'blur' }],
                diploma: [{ required: true, message: '层次不能为空', trigger: 'blur' }],
                schProfName: [{ required: true, message: '开设专业名称不能为空', trigger: 'blur' }],
                dataYear: [{ required: true, message: '数据年份不能为空', trigger: 'blur' }],
                schoolId: [{ required: true, message: '院校名称不能为空', trigger: 'blur' }]
            },
            searchByKeyword: {
                dataId: '',
                diploma: '',
                schoolName: '',
                profName: '',
                schoolId: ''
            },
            diplomaList: [
                { name: '本科', value: 1 },
                { name: '专科', value: 2 }
            ],
            searchSchool: {
                keywords: ''
            },
            showImport: false,
            importUrl: '',
            upload: {
                url: uploadUrl + '/common/image/upload',
                videoUrl: uploadUrl + '/common/file/upload',
                pdfUrl: uploadUrl + '/article/pdf/upload'
            },
            headers: {
                'access-token': sessionStorage.getItem('access-token')
            },
            loadingInstance: null,
            isHTML: false
        }
    },
    methods: {
        getSchoolList(params) {
            console.log(params)
            if (params !== '') {
                this.searchSchool.keywords = params
                this.$api.ZlInfo.getSchoolList(this.searchSchool).then(res => {
                    if (res && !res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }
                    this.schoolList = res.data
                })
            }
        },
        selectionChange(selections) {
            console.log(selections)
        },
        handleCurrentHandle: function(val) {
            console.log('handleCurrentHandle>>' + val)
        },
        handleShoMore(item) {
        },
        // 添加
        handleAdd() {
            console.log(this.dataForm)
            this.dataForm = {
                dataId: '',
                profId: '',
                profName: '',
                diploma: '',
                dataYear: '',
                schProfName: '',
                schoolId: '',
                schoolName: '',
                remark: '',
                intro: ''
            }
            this.initEditor()
            this.dialogVisible = true
        },
        // 获取分页数据
        findPage: function(data) {
            this.loading = true
            if (data != null) {
                this.pageRequest = data.pageRequest
            }
            let param = {}
            try {
                this.filters = data.filters ? data.filters : this.filters
                this.pageRequest = data.pageRequest ? data.pageRequest : this.pageRequest
            } catch (error) {
                if (error) {
                    // filters = {}
                }
            }
            if (this.searchByKeyword.dataId || this.searchByKeyword.profName || this.searchByKeyword.schoolId || this.searchByKeyword.diploma) {
                param = Object.assign(this.searchByKeyword, this.pageRequest)
            } else {
                param = Object.assign(param, this.pageRequest, this.filters)
            }
            this.$api.schoolProf.searchSchoolProfList(param).then(res => {
                if (res && !res.success) {
                    this.$message({ message: res.message, type: 'error' })
                    this.loading = false
                    return
                }
                this.page = res.data

                this.loading = false
            }).then(data != null ? data.callback : '')
        },
        // 显示编辑界面
        handleEdit: function(data) {
            const param = {
                dataId: data.row.dataId
            }
            this.$api.schoolProf.getSchoolProfInfo(param).then(res => {
                Object.assign(this.dataForm, res.data)
                this.initEditor(res.data.intro)
                console.log(this.dataForm)
                this.schoolList = [{ 'schoolId': this.dataForm.schoolId, 'schoolName': this.dataForm.schoolName }]
            })
            this.dialogVisible = true
        },
        // 删除
        handleDelete(data) {
            this.$confirm('确认删除选中记录吗？', '提示', {
                type: 'warning'
            }).then(() => {
                const params = this.getDeleteIds([], data.row)
                this.$api.schoolProf.deleteSchoolProf(params).then(res => {
                    if (!res.success) {
                        this.$message({ message: res.message, type: 'error' })
                        return
                    }
                    this.$message({ message: '删除成功', type: 'success' })
                    this.findPage(null)
                })
            })
        },
        // 处理表格列过滤显示
        displayFilterColumnsDialog: function() {
            this.$refs.tableColumnFilterDialog.setDialogVisible(true)
        },
        // 处理表格列过滤显示
        handleFilterColumns: function(data) {
            this.filterColumns = data.filterColumns
            this.$refs.tableColumnFilterDialog.setDialogVisible(false)
        },
        submitForm() {
            var callback = (res) => {
                this.editLoading = false
                if (res.success) {
                    this.$message({ message: '操作成功', type: 'success' })
                    this.$refs['dataForm'].resetFields()
                    this.dialogVisible = false
                    this.$nextTick(() => {
                        this.$refs['dataForm'].resetFields()
                    })
                    // 当前页
                    this.findPage(null)
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    })
                }
            }
            this.$refs['dataForm'].validate(valid => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {}).then(() => {
                        this.editLoading = true
                        const params = Object.assign({}, this.dataForm)
                        console.log(JSON.stringify(params))
                        params.intro = this.editor.getData()
                        // params
                        debugger
                        const result = !this.dataForm.dataId ? this.$api.schoolProf.addSchoolProf(params) : this.$api.schoolProf.editSchoolProf(params)
                        result.then(res => {
                            callback(res)
                        })
                    })
                }
            })
        },
        cancel: function() {
            this.dialogVisible = false
            this.destroeee()
            this.$refs.dataForm.resetFields()
            this.schoolList = []
            this.editor.setData('')
            this.$forceUpdate()
        },
        destroeee() {
            if (this.summaryBox) {
                this.isHTML = false
                this.summaryBox.destroy()
                this.wEditor = null
            }
        },
        // 初始化表格
        initColumns: function() {
            this.columns = [
                { prop: 'dataId', label: '数据ID', minWidth: 80 },
                { prop: 'dataYear', label: '数据年份', minWidth: 80 },
                { prop: 'schoolName', label: '院校名称', minWidth: 100 },
                { prop: 'schProfName', label: '开设专业名称', minWidth: 120 },
                { prop: 'profName', label: '选专业名称', minWidth: 120 },
                { prop: 'diploma', label: '层次', minWidth: 70, formatter: this.formatPlatForm }
            ]
            this.filterColumns = JSON.parse(JSON.stringify(this.columns))
        },
        formatPlatForm(q, w, row) {
            var text = '未知'
            w.renderCell = (h, params) => {
                switch (params.row.diploma) {
                    case 1:
                        text = '本科'
                        break
                    case 2:
                        text = '专科'
                        break
                }
                // debugger
                return h('span', {
                    style: {
                        'max-width': '100px',
                        'cursor': 'pointer'
                    }
                }, text)
            }
        },
        // initEditor(con) {
        //     var _this = this
        //     setTimeout(() => {
        //         const wEditor = new E('#intro')
        //         const { $, BtnMenu, DropListMenu, PanelMenu, DropList, Panel, Tooltip } = E
        //         class AlertMenu extends BtnMenu {
        //             constructor(editor) {
        //                 const $elem = E.$(
        //                     `<div class="w-e-menu" id='firstHtml'>
        //                         <span>HTML</span>
        //                     </div>`
        //                 )
        //                 super($elem, editor)
        //             }
        //             // 菜单点击事件
        //             clickHandler(r, t, y) {
        //                 _this.showSource()
        //                 this.tryChangeActive()
        //             }
        //             tryChangeActive() {
        //                 debugger
        //                 var $elem = this.$elem
        //                 if (_this.isHTML) {
        //                     this.active()
        //                     // $elem.addClass('w-e-active')
        //                     const ele = document.getElementById('firstHtml')
        //                     ele.style.cssText = 'color:#484a4d;background:#43bbff;padding:0 2px;color:#fff;'
        //                     // console.log(document.getElementsByName('firstHtml'))
        //                 } else {
        //                     this.unActive()
        //                     const ele = document.getElementById('firstHtml')
        //                     ele.style.cssText = ''
        //                     // $elem.removeClass('w-e-active')
        //                 }
        //             }
        //         }
        //         wEditor.customConfig = {
        //             uploadImgServer: `${uploadUrl}/common/image/upload`, // 上传图片到服务器
        //             uploadFileName: 'data', // 后端使用这个字段获取图片信息
        //             uploadImgMaxLength: 1 // 限制一次最多上传 1 张图片
        //         }
        //         wEditor.config.onchange = (html) => {
        //             // this.dataForm.summary = html
        //             this.dataForm.intro = html
        //         }
        //         const menuKey = 'alertMenuKey' // 菜单 key ，各个菜单不能重复
        //         wEditor.menus.extend('alertMenuKey', AlertMenu)
        //         wEditor.config.menus = wEditor.config.menus.concat(menuKey)
        //         wEditor.config.showLinkImg = false
        //         wEditor.config.uploadImgShowBase64 = true
        //         wEditor.config.uploadImgServer = `${uploadUrl}/common/image/upload`
        //         wEditor.config.uploadImgHeaders = {
        //             'access-token': `${sessionStorage.getItem('access-token')}`
        //         }
        //         wEditor.config.customUploadImg = (resultFiles, insertImgFn) => {
        //             console.log(resultFiles)
        //             for (var s = 0; s < resultFiles.length; s++) {
        //                 var formData = new FormData()
        //                 formData.append('file', resultFiles[s])
        //                 this.$api.area.upload(formData).then(res => {
        //                     if (res.success) {
        //                         insertImgFn(res.data)
        //
        //                         // this..$set(that.arrayList[index], 'paper', res.data)
        //                     }
        //                 })
        //             }
        //         }
        //         wEditor.create()
        //         this.summaryBox = wEditor
        //         if (con) {
        //             this.summaryBox.txt.html(con)
        //         }
        //     }, 500)
        // },
        initEditor(con) {
            const { ClassicEditor } = window
            this.$nextTick(() => {
                if (this.editor) {
                    this.editor.setData(con)
                    const contentWrap = document.querySelector('.ck-content')
                    contentWrap.scroll(0, 0)
                    return
                }
                const el = document.getElementById('editor')
                const config = {
                    language: 'zh-cn',
                    extraPlugins: [MyCustomUploadAdapterPlugin],
                    htmlSupport: {
                        allow: [
                            {
                                name: 'section',
                                attributes: true,
                                styles: true
                            },
                            {
                                name: 'video',
                                attributes: true,
                                styles: true
                            },
                            {
                                name: 'p',
                                attributes: true,
                                styles: true
                            }
                        ]
                    }
                }
                ClassicEditor.create(el, config).then((editor) => {
                    this.editor = editor
                    if (con) {
                        this.editor.setData(con)
                    }
                })
            })
        },
        showSource() {
            const _this = this
            const _editor = _this.summaryBox
            _this.isHTML = !_this.isHTML
            let _source = _editor.txt.html()
            if (_this.isHTML) {
                _source = _source.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/ /g, '&nbsp;')
            } else {
                _source = _editor.txt.text().replace(/&lt;/ig, '<').replace(/&gt;/ig, '>').replace(/&nbsp;/ig, ' ')
            }
            _editor.txt.html(_source)
        },
        // 获取删除的统考id
        getDeleteIds(ids, row) {
            console.log(row)
            debugger
            ids.push(row.dataId)
            if (row.children != null) {
                for (let i = 0, len = row.children.length; i < len; i++) {
                    this.getDeleteIds(ids, row.children[i])
                }
            }
            return ids
        },
        handleCancelImportByUrl() {
            this.showImport = false
            this.importUrl = ''
        },
        handleImportByUrl() {
            if (!this.importUrl) {
                this.$message.error('文章链接不能为空')
                return
            }
            const data = {
                url: this.importUrl
            }
            this.$api.article.importArticleByUrl(data).then(res => {
                if (res.success) {
                    if (this.editor.setData) {
                        this.editor.setData(res.data)
                        this.handleCancelImportByUrl()
                    }
                } else if (res.message) {
                    this.$message.error(res.message)
                }
            })
        },
        beforePDFUpload() {
            this.loadingInstance = Loading.service({ fullscreen: true })
        },
        handleErrorPDF() {
            this.loadingInstance.close()
        },
        handleSuccessPDF(response, file, fileList) {
            if (response.success) {
                const imgList = response.data.map(v => {
                    const imgUrl = `${v.replace(
                        'easywish/',
                        'http://static.lpswish.com/'
                    )}?x-oss-process=image/resize,w_750`
                    const imgTag = `<p><img src="${imgUrl}"/></p>`
                    return imgTag
                })
                const html = imgList.join('')
                this.insertHTML(html)
                this.$refs.upLoadPDFForm.clearFiles()
            }
            this.loadingInstance.close()
        },
        insertHTML(html) {
            if (!html) {
                return
            }
            const viewFragment = this.editor.data.processor.toView(html)
            const modelFragment = this.editor.data.toModel(viewFragment)
            this.editor.model.insertContent(modelFragment)
        }
    },
    mounted() {
        this.initColumns()
        this.provinceList = this.$store.state.baseProvinceList.provinceList
        this.findPage()
    }
}
</script>

<style scoped>
    .el-input{
        width: 300px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Manager/Tkinfo/SchoolProf.vue